<template>
    <div class="testDetail">
        <div class='testDetail-top'>
            <van-nav-bar title="练习" left-arrow @click-left="back" />
        </div>
        <div class="testDetail-content">
            <img class="bg" src="../../../assets/images/trainTest/testbg@2x.png" alt="">
            <div class="content-title">
                <h2>{{testInfo.practiceName}}</h2>
            </div>
            <div class="content-model">
                <ul>
                    <li v-for="item in modelList" :key="item.id" @click="goTest(item)">
                        <div class="typeImg">
                            <img :src="item.icon" alt="">
                        </div>
                        
                        <div class="modelright">
                            <div class="right-top">
                                <p class="modelType">
                                    <span class="name">{{item.name}}</span>
                                    <span v-if="item.id === 1" class="prevTitle">{{testInfo.commitLastSequence ? testInfo.totalCount : (testInfo.sequence !==null ? testInfo.sequence: 0)}}</span><span v-if="item.id === 1" class="alltotal">/{{testInfo.totalCount || 100}}</span>
                                    <span v-if="[3,4].includes(item.id)" class="alltotal">总题数:{{ item.id === 3 ? testInfo.markCount : testInfo.errorsCount}}</span>
                                </p>
                                <img src="../../../assets/images/trainTest/right@2x.png" alt="">
                            </div>
                            <p class="right-bottom">{{item.tips}}</p>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <van-dialog class="testdialog" v-model="allowCheck" title :show-confirm-button="false">
            <img class="allowImg" src="../../../assets/images/trainTest/jinggao@2x.png" alt />
            <h2 class="allowH2">提示</h2>
            <p v-if="!testInfo.commitLastSequence" class="allowP">上次练到第
                <span>{{testInfo.sequence}} </span>题，是否继续练习？
            </p>
            <p v-else class="allowP">
                上次练习已全部完成，是否从头练习？
            </p>
            <van-button v-if="!testInfo.commitLastSequence"
                class="allowBtn1 allowBtn"
                round
                type="info"
                plain
                @click="orderTestCancal()"
            >取消</van-button>
            <van-button v-else
                class="allowBtn1 allowBtn"
                round
                type="info"
                plain
                @click="orderTestCancal('prev')"
            >查看上次练习</van-button>
            <van-button class="allowBtn2 allowBtn" round type="info" plain @click="orderTestOK( null,'ok')">确定</van-button>
        </van-dialog>
    </div>
</template>

<script>
export default {
    name: 'testDetail',
    data() {
        return {
            allowCheck: false,
            infoparams: {},
            testInfo: {},
            modelList: [
                {id: 1, name: '顺序练习', tips: '全部试题按照顺序进行练习，初次进入建议顺序练习。', icon: require('../../../assets/images/trainTest/shunxu@2x.png')},
                {id: 2, name: '随机练习', tips: '知识点交叉练习，每次进入练习顺序被打乱，适用于对基础知识已有基本掌握。', icon: require('../../../assets/images/trainTest/suiji@2x.png')},
                {id: 4, name: '错题本', tips: '针对错题巩固练习，答题正确后，试题将移除错题本。', icon: require('../../../assets/images/trainTest/cuoti@2x.png')},
                {id: 3, name: '我的标记', tips: '练习过程中对掌握不深刻的试题标记后，试题将进入”我的标记”，可再次回顾练习。', icon: require('../../../assets/images/trainTest/mybiaoji@2x.png')}
            ],
        };
    },
    components: {},
    methods: {
        back() {
            if(this.$route.query.taskType){
                
                this.$router.push({
                    path: '/learning/task/detail',
                    query: {
                        id: this.$route.query.taskId || this.$route.query.businessId,
                        backType: this.$route.query.backType,
                        backPath: this.$route.query.backPath,
                        goodsId:this.$route.query.goodsId,
                        goodsKind:this.$route.query.goodsKind,
                    }
                })
            }else {
                this.$router.push({
                    path: '/learning',
                    query: {backType: this.$route.query.backType},
                })
            }
            
        },
        jumpTest(num, id) {
            let {businessId, businessType, practiceId, taskType, backType} = this.infoparams
            let last = (num || num === 0) ? {lastTopic: num} : {}
            this.$router.push({
                path: '/testTrain',
                query: {
                    userPracticeId: id,
                    businessId,
                    businessType,
                    practiceId,
                    backType,
                    taskType,
                    backPath: this.$route.query.backPath,
                    goodsId:this.$route.query.goodsId,
                    goodsKind:this.$route.query.goodsKind,
                    ...last,
                }
            })
        },
        // 取消
        orderTestCancal(type){
            if(type){
                this.jumpTest(null, this.testInfo.lastSequenceUserPracticeId);
            }else{
                this.joinExam({id:1}, 0);
            }
            this.allowCheck = false;
        },
        orderTestOK() {
            if(this.testInfo.commitLastSequence){
                this.joinExam({id:1}, 0);
            } else {
                this.testInfo.sequence = this.testInfo.sequence || 0
                this.jumpTest(this.testInfo.sequence, this.testInfo.lastSequenceUserPracticeId)
                this.allowCheck = false;
            }
        },
        // 
        joinExam(val, num) {
            let {businessId, businessType, practiceId} = this.infoparams
            let params = {
                businessId,
                businessType,
                practiceId,
                practiceModel: val.id,
            }
            this.$api.exam.userPracticejoinExam({params}).then(res => {
                if(res.code === 0 && res.success){
                    let data = res.data;
                    this.jumpTest(num, data)
                }
            })
        },
        goTest(val){
            this.allowCheck = val.id === 1 && this.testInfo.attendSequence && (this.testInfo.sequence>0 || this.testInfo.sequence === null)
            if(this.allowCheck) return false
            if(!this.testInfo.errorsCount && val.id === 4){
                this.$toast('暂无错题')
                return false;
            } else if(!this.testInfo.markCount && val.id === 3){
                this.$toast('暂无标记试题')
                return false;
            }
            this.joinExam(val, 0);
        },
        modelInfo() {
            let {businessId, businessType, practiceId} = this.infoparams
            let params = {
                businessId,
                businessType,
                practiceId
            }
            this.$api.trainTest.modelInfo({params}).then(res => {
                if(res.code === 0 && res.success){
                    this.testInfo = res.data
                }
            })
        }
    },
    destroyed() {
        window.removeEventListener("popstate", this.back, false); //false阻止默认事件
    },
    created() {
        this.infoparams = this.$route.query
        console.log(this.infoparams)
        this.modelInfo();
    },
    mounted() {
        if (window.history && window.history.pushState) {
            // 往历史记录里面添加一条新的当前页面的url
            history.pushState(null, null, document.URL);
            // 给 popstate 绑定一个方法 监听页面刷新
            window.addEventListener("popstate", this.back, false); //false阻止默认事件
        }
    },
};
</script>

<style scoped lang="less">
@import '../asset/css/testDetail';
</style>
